import { normalizeForComparison, stringSimilarity, type SongRequest } from '../services/requests';

const TITLE_MIN_SCORE = 0.6;
const ARTIST_PART_MIN_SIMILARITY = 0.8;
const ARTIST_BONUS = 0.25;

function titleScore(heardTitle: string, queueTitle: string): number {
  const heard = normalizeForComparison(heardTitle);
  const queued = normalizeForComparison(queueTitle);
  const contains = heard !== '' && queued !== '' && (heard.includes(queued) || queued.includes(heard));
  return stringSimilarity(heard, queued) + (contains ? 1 : 0);
}

function artistMatches(heardArtist: string, queueArtist: string): boolean {
  const queued = normalizeForComparison(queueArtist);
  if (queued === '') return false;
  return heardArtist
    .split(/,|&|\s+feat\.\s*|\s+ft\.\s*|\s+and\s+/i)
    .map((part) => normalizeForComparison(part))
    .some((part) => part !== '' && stringSimilarity(part, queued) >= ARTIST_PART_MIN_SIMILARITY);
}

// Loose guesses for the off-track pick list only (ITER-181) — never used to move the queue
export function likelyMatches<T extends { request: SongRequest; position: number }>(
  heard: { title: string; artist: string } | null,
  rows: T[],
  max = 3,
): T[] {
  if (!heard) return [];
  return rows
    .map((row) => {
      const title = titleScore(heard.title, row.request.song.title);
      const bonus = artistMatches(heard.artist, row.request.song.artist) ? ARTIST_BONUS : 0;
      return { row, title, total: title + bonus };
    })
    .filter((scored) => scored.title >= TITLE_MIN_SCORE)
    .sort((a, b) => b.total - a.total || a.row.position - b.row.position)
    .slice(0, max)
    .map((scored) => scored.row);
}
